import axios from 'axios'
import AuthService from '@/services/AuthService';

const instance = axios.create({
    baseURL: process.env.VUE_APP_MASTERS_API_URL
});
export default {
    getLevel: async function () {
        try {
            const response = await instance.get('levels')
            return response;
        } catch (error) {
            return error.response;
        }
    },
    getLevelByPagination: async function (query) {
        try {
            const response = await instance.get('levels'+query)
            return response;
        } catch (error) {
            return error.response;
        }
    },



    updateLevel: async function (data,id) {
               try {
                console.log("data from updata level controller",data)
            const response = await instance.put('level?id='+id,data,{
                headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },


    

   createLevel : async function (data) {
        try {
            const response = await instance.post('level',
               data
               ,
               {
                headers: {
                    'Authorization': AuthService.getToken()
                  }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },



    deleteLevel : async function (id) {
        console.log("delete selected id",id)
        try {
            const response = await instance.delete('admin/meta/levels/'+id,
             { headers: {
                'Authorization': AuthService.getToken()
              }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },
    deleteBulkLevel : async function (ids) {
        console.log("delete selected id",ids)
        try {
            const response = await instance.delete('levels',{
               data:{
                ids:ids
               }
            },
             { headers: {
                'Authorization': AuthService.getToken()
              }
            })
            return response;
        } catch (error) {
            return error.response;
        }
    },
    filterLevel : async function (grades){
        console.log("filter function called");
        try{
            const response = await instance.put('/filterLevels',{grades},
            {
                headers:{
                    'Authorization':AuthService.getToken()
                }
            })
            return response;
        }
        catch (error){
            return error.response;
        }
    },
    searchLevel: async function (search) {
        try {
            const response = await instance.get('/filterLevels='+search)
            return response;
        } catch (error) {
            return error.response;
        }
    },
    getLevelByGroupName: async function (jobTypeId = null) {
        try {
            const response = await instance.get('/levels?audienceRoleGroupId='+jobTypeId)
            console.log('response',response)
            return response;
        } catch (error) {
            return error.response;
        }
    },
    



}